import axios from 'axios';
import {
  baseUrlSolicitante,
  getAuthHeader,
  refreshAccessToken,
  limparSessao,
} from './tokenManager';

const api = axios.create({ timeout: 20000 });

api.interceptors.request.use((config) => {
  if (!config.baseURL) {
    config.baseURL = baseUrlSolicitante();
  }
  const auth = getAuthHeader();
  if (auth.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = auth.Authorization;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const status = error?.response?.status;
    const original = error?.config || {};
    const ehRotaAuth = typeof original.url === 'string' && /\/(api\/)?(refresh|token)(\b|\/|$)/.test(original.url);

    if (status === 401 && !original._retry && !ehRotaAuth) {
      original._retry = true;
      const novoToken = await refreshAccessToken();
      if (novoToken) {
        original.headers = original.headers || {};
        original.headers.Authorization = novoToken.startsWith('Bearer ') ? novoToken : 'Bearer ' + novoToken;
        return api(original);
      }
      limparSessao();
    }
    return Promise.reject(error);
  }
);

export default api;
